import angular from 'angular';

CatalogService.$inject = ['$resource', 'appconfig'];

function CatalogService($resource, appconfig) {
    return $resource(appconfig.apiEndpoint + "/catalog/:id/:command", {id: '@id', command: '@command', type: '@type'}, {
        update: {
            method: 'PUT'
        }
    });

}

export default angular.module('catalog.service', [])
    .factory('CatalogService', CatalogService)
    .name;
